var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#262626"},[React.createElement("path",{"d":"m18.9919 15.75h-17.9838c-.556739 0-1.0081.5037-1.0081 1.125s.451361 1.125 1.0081 1.125h17.9838c.5567 0 1.0081-.5037 1.0081-1.125s-.4514-1.125-1.0081-1.125z","key":0}),React.createElement("path",{"d":"m18.9919 7.875h-17.9838c-.556739 0-1.0081.5037-1.0081 1.125 0 .62129.451361 1.125 1.0081 1.125h17.9838c.5567 0 1.0081-.50371 1.0081-1.125 0-.6213-.4514-1.125-1.0081-1.125z","key":1}),React.createElement("path",{"d":"m18.9919 0h-17.9838c-.556739 0-1.0081.503702-1.0081 1.125 0 .62129.451361 1.125 1.0081 1.125h17.9838c.5567 0 1.0081-.50371 1.0081-1.125 0-.621298-.4514-1.125-1.0081-1.125z","key":2})]));
}

Menu.defaultProps = {"fill":"none","height":"18","viewBox":"0 0 20 18","width":"20"};

module.exports = Menu;

Menu.default = Menu;
